import { AddressedPositionTypeEnum } from '@/services/ws-post/src/main/resources/rest-api';

export const REACH_BY_DELIVERY_FACTOR = 2.675;

export const HOLIDAYS = [
  '04-07-2023',
  '04-09-2023',
  '04-10-2023',
  '05-01-2023',
  '05-18-2023',
  '05-28-2023',
  '05-29-2023',
  '06-08-2023',
  '08-01-2023',
  '08-15-2023',
  '09-08-2023',
  '11-01-2023',
  '12-25-2023',
  '12-26-2023',
  '01-01-2024',
  '01-02-2024',
  '01-06-2024',
  '03-29-2024',
  '04-01-2024',
  '04-09-2024',
  '05-01-2024',
  '04-18-2025',
  '04-20-2025',
  '04-21-2025',
  '05-29-2025',
  '06-08-2025',
  '06-09-2025',
  '06-19-2025',
  '08-01-2025',
  '08-15-2025',
  '09-08-2025',
  '11-01-2025',
  '12-08-2025',
  '12-25-2025',
  '12-26-2025',
  '01-01-2026',
  '01-02-2026',
  '01-06-2026',
  '04-03-2026',
  '04-05-2026',
  '04-06-2026',
  '05-01-2026',
  '05-14-2026',
  '05-24-2026',
  '05-25-2026',
  '06-04-2026',
  '08-01-2026',
  '08-15-2026',
  '09-08-2026',
  '11-01-2026',
  '12-08-2026',
  '12-25-2026',
  '12-26-2026',
  '01-01-2027',
  '01-02-2027',
  '01-06-2027',
  '03-26-2027',
  '03-28-2027',
  '03-29-2027',
  '05-01-2027',
  '05-06-2027',
  '06-16-2027',
  '06-17-2027',
  '06-27-2027',
  '08-01-2027',
  '08-15-2027',
  '09-08-2027',
  '11-01-2027',
  '12-08-2027',
  '12-25-2027',
  '12-26-2027',
  '01-01-2028',
  '01-02-2028',
  '01-06-2028',
  '04-14-2028',
  '04-16-2028',
  '04-17-2028',
  '05-01-2028',
  '05-25-2028',
  '06-04-2028',
  '06-05-2028',
  '06-15-2028',
  '08-01-2028',
  '08-15-2028',
  '09-08-2028',
  '11-01-2028',
  '12-08-2028',
  '12-25-2028',
  '12-26-2028',
  '01-01-2029',
  '01-02-2029',
  '01-06-2029',
  '03-30-2029',
  '04-01-2029',
  '04-02-2029',
  '05-01-2029',
  '05-10-2029',
  '05-20-2029',
  '05-21-2029',
  '05-31-2029',
  '08-01-2029',
  '08-15-2029',
  '09-08-2029',
  '11-01-2029',
  '12-08-2029',
  '12-25-2029',
  '12-26-2029',
  '01-01-2030',
  '01-02-2030',
  '01-06-2030',
  '04-19-2030',
  '04-21-2030',
  '04-22-2030',
  '05-01-2030',
  '05-30-2030',
  '06-09-2030',
  '06-10-2030',
  '06-20-2030',
  '08-01-2030',
  '08-15-2030',
  '09-08-2030',
  '11-01-2030',
  '12-08-2030',
  '12-25-2030',
  '12-26-2030',
  '01-01-2031',
  '01-02-2031',
  '01-06-2031',
  '04-11-2031',
  '04-13-2031',
  '04-14-2031',
  '05-01-2031',
  '05-22-2031',
  '06-01-2031',
  '06-02-2031',
  '06-20-2031',
  '08-01-2031',
  '08-15-2031',
  '09-08-2031',
  '11-01-2031',
  '12-08-2031',
  '12-25-2031',
  '12-26-2031',
] as const;

export const MAILING_CHANNELS = [
  AddressedPositionTypeEnum.INITIAL_EMAIL,
  AddressedPositionTypeEnum.INITIAL_ADDRESSED,
  AddressedPositionTypeEnum.INITIAL_SHIPMENT,
  AddressedPositionTypeEnum.REMINDER_EMAIL,
  AddressedPositionTypeEnum.REMINDER_ADDRESSED,
  AddressedPositionTypeEnum.REMINDER_SHIPMENT,
] as const;

export const MAX_RUNTIME_DAYS = 350;

export const POST_ENDPOINTS = [
  import.meta.env.VITE_POST_CONSOLE_ENDPOINT,
  import.meta.env.VITE_POST_CONSOLE_ENDPOINT_LEGACY,
  import.meta.env.VITE_POSTNETZ_CONSOLE_ENDPOINT,
  import.meta.env.VITE_POSTNETZ_CONSOLE_ENDPOINT_LEGACY,
];
